module.exports = "/v2/pages/dashboard/dist/39205435621b4b973ad6535e507f4594.svg";